export function HorizontalList({
  children,
  gap = 'md',
  className = '',
  ...props
}) {
  const classes = [
    'horizontal-list',
    gap ? `horizontal-list--gap-${gap}` : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div className={classes} {...props}>
      {children}
    </div>
  );
}

export function HorizontalListItem({
  thumbnail,
  title,
  subtitle,
  badges,
  meta,
  pricing,
  stats,
  actions,
  children,
  interactive = false,
  onClick,
  className = '',
  ...props
}) {
  const classes = [
    'horizontal-item',
    interactive || onClick ? 'horizontal-item--interactive' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <div
      className={classes}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      onKeyDown={
        onClick
          ? (e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onClick(e);
              }
            }
          : undefined
      }
      {...props}
    >
      {thumbnail && <div className="horizontal-item__thumb">{thumbnail}</div>}

      <div className="horizontal-item__content">
        <div className="horizontal-item__main">
          {title && (
            <div className="horizontal-item__title-row">
              <h4 className="horizontal-item__title">{title}</h4>
            </div>
          )}
          {badges && <div className="horizontal-item__badges">{badges}</div>}
          {subtitle && <div className="horizontal-item__subtitle">{subtitle}</div>}
          {meta && <div className="horizontal-item__meta">{meta}</div>}
          {children && <div className="horizontal-item__children">{children}</div>}
        </div>

        {(pricing || stats) && (
          <div className="horizontal-item__details">
            {pricing && <div className="horizontal-item__pricing">{pricing}</div>}
            {stats && <div className="horizontal-item__stats">{stats}</div>}
          </div>
        )}

        {actions && (
          <div
            className="horizontal-item__actions"
            onClick={(e) => e.stopPropagation()}
          >
            {actions}
          </div>
        )}
      </div>
    </div>
  );
}

export default HorizontalList;

